<template>
  <div>
    <b-row>
      <b-col md="1"> </b-col>
      <b-col md="10">
        <b-card md="1" bg-variant="none"> {{ description }}</b-card>
      </b-col>
      <b-col md="1" v-if="schema_obj.required_relationships">
          <b-dropdown size="sm" variant="none" toggle-class="text-decoration-none" dropleft no-caret>
            <template #button-content>
              <!-- &#x1f50d;<span class="sr-only">Search</span> -->
                <b-button size="sm"
                  variant="primary" 
                  class="mb-2"
                  v-b-tooltip.hover.up title="Update Relationship"
                >
                <b-icon-triangle aria-label="Update"></b-icon-triangle>
              </b-button>
            </template>
            <b-dropdown-item-button variant="primary" v-for="relationship in schema_obj.required_relationships" :key="relationship" @click="selectRelationship(relationship)">
              {{ relationship }}
            </b-dropdown-item-button>
        </b-dropdown>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {BIconTriangle} from 'bootstrap-vue'
import {belongsToDescription} from '@/utils'
import {amsSchema} from '@/schema'

export default {
  components: {
    BIconTriangle
  },
  props: {
    ams_type: {
      Type: String
    },
    ams_template: {
      Type: Object
    },
    response_data: {
      Type: Object
    },
    response_included: {
      Type: Array
    }
  },
  data () {
    return {
      description: undefined,
      schema_obj: {}
    }
  },
  methods: {
    selectRelationship(relationship) {
      this.$emit('updateRelationship', relationship)
    }
  },
  watch: {
    response_data() {
      this.schema_obj = amsSchema.find(el => el.type === this.ams_type)
      this.description = belongsToDescription(
        this.response_data, this.response_included, this.schema_obj.describe_belongs_to
      )
      this.$emit('descriptionUpdate', this.description)
    }
  }
}
</script>